import { PaymentOptionType } from '~/lib/api/smartsend/types';
import { SettingsCache } from '~/lib/consts/settings-cache';

export const CanUseDiscount = (p: PaymentOptionType): boolean => {
  if (!SettingsCache.settings.Features.includes('Discounts')) {
    return false;
  }

  switch (p) {
    case 'External':
    case 'SavedPayment':
    case 'TopUp':
      return true;
    default:
      return false;
  }
};
